document.addEventListener('DOMContentLoaded', () => {
	const targets = document.querySelectorAll('.reveal, .reveal-group, .section-title, .column-block-list, .pages-head-container, .wp-block-columns.is-style-shift');
	if (!targets.length) return;

	if (!('IntersectionObserver' in window)) {
		targets.forEach((el) => el.classList.add('is-inview'));
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			entry.target.classList.add('is-inview');
			observer.unobserve(entry.target);
		});
	}, {
		threshold: 0,
		rootMargin: '0px 0px -5% 0px',
	});

	targets.forEach((el) => observer.observe(el));
});
